import React from 'react'

import { Icon } from '@fourthwall/components'
import { PayPalIcon } from '@fourthwall/icons'
import { CreditCardIcon } from '@modules/Dashboard/modules/PaymentMethods'

import type { PaymentMethod as PaymentMethodType } from '../../Billing.types'
import * as S from './PaymentMethod.styled'

type ChargesHistoryListItemProps = {
  method: PaymentMethodType
}

export const PaymentMethod = ({ method }: ChargesHistoryListItemProps) => {
  if (method.type === 'CARD') {
    return (
      <S.Container>
        <CreditCardIcon brand={method.brand} size={24} />
        <span>{method.last4Digits}</span>
      </S.Container>
    )
  }

  if (method.type === 'PAYPAL') {
    return (
      <S.Container>
        <Icon component={PayPalIcon} height={24} />
      </S.Container>
    )
  }

  // Unknown
  return <>-</>
}
